(function () {
  'use strict';

  function initPdpSwatches() {
    var container = document.querySelector('.product-swatches--pdp[data-size-option-name]');
    if (!container) return;

    var sizeOptionName = container.dataset.sizeOptionName;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    function getSelectedSize() {
      var checked = form.querySelector('input[name="' + sizeOptionName + '"]:checked');
      if (checked) return checked.value;
      var select = form.querySelector('select[name="' + sizeOptionName + '"]');
      if (select) return select.value;
      return null;
    }

    function refreshSwatchHrefs() {
      var selectedSize = getSelectedSize();

      container.querySelectorAll('.product-swatch:not(.is-active)').forEach(function (swatch) {
        var baseUrl = swatch.dataset.productUrl;
        if (!baseUrl) return;

        if (!selectedSize) {
          swatch.href = baseUrl;
          return;
        }

        try {
          var sizeMap = JSON.parse(swatch.dataset.sizeMap || '{}');
          var variantId = sizeMap[selectedSize];
          swatch.href = variantId ? (baseUrl + '?variant=' + variantId) : baseUrl;
        } catch (e) {
          swatch.href = baseUrl;
        }
      });
    }

    form.addEventListener('change', refreshSwatchHrefs);
    document.addEventListener('variant:changed', refreshSwatchHrefs);
    refreshSwatchHrefs();
  }

  function initPlpSwatchHover() {
    if (!window.matchMedia('(hover: hover)').matches) {
      document.querySelectorAll('.product-swatch[data-hover-image]').forEach(function (el) {
        el.removeAttribute('data-hover-image');
      });
      return;
    }

    document.querySelectorAll('.product-swatches--plp:not([data-swatch-init])').forEach(function (container) {
      container.setAttribute('data-swatch-init', '1');

      var card = container.closest('.product-card');
      if (!card) return;

      var carouselTrack = card.querySelector('.product-carousel-track');
      var carousel      = card.querySelector('product-card-carousel');
      var figure        = card.querySelector('.product-featured-image');
      if (!figure) return;

      if (window.getComputedStyle(figure).position === 'static') {
        figure.style.position = 'relative';
      }

      var overlay = document.createElement('div');
      overlay.style.cssText = 'position:absolute;top:0;left:0;right:0;bottom:0;background-size:cover;background-position:center;display:none;pointer-events:none;z-index:9';
      figure.appendChild(overlay);

      var savedIndex  = null;
      var moveHandler = null;

      function restoreCarousel() {
        if (!carouselTrack || savedIndex === null) return;
        var enableLoop = carousel && carousel.dataset.loop !== 'false';
        carouselTrack.scrollLeft = enableLoop
          ? (savedIndex + 1) * carouselTrack.clientWidth
          : savedIndex * carouselTrack.clientWidth;
      }

      function restore() {
        if (overlay.style.display === 'none') return;
        restoreCarousel();
        overlay.style.display = 'none';
        overlay.style.backgroundImage = '';
        savedIndex = null;
        if (moveHandler) {
          document.removeEventListener('mousemove', moveHandler);
          moveHandler = null;
        }
      }

      container.querySelectorAll('.product-swatch[data-hover-image]').forEach(function (swatch) {
        swatch.addEventListener('mouseenter', function () {
          if (!window.matchMedia('(hover: hover)').matches) return;
          if (overlay.style.display === 'none') {
            savedIndex = carousel
              ? (parseInt(carousel.dataset.currentIndex, 10) || 0)
              : null;
            if (carouselTrack) {
              var enableLoop = carousel && carousel.dataset.loop !== 'false';
              carouselTrack.scrollLeft = enableLoop ? carouselTrack.clientWidth : 0;
            }
            moveHandler = function (e) {
              if (!document.contains(container)) { restore(); return; }
              var rect = container.getBoundingClientRect();
              if (e.clientX < rect.left || e.clientX > rect.right ||
                  e.clientY < rect.top  || e.clientY > rect.bottom) {
                restore();
              }
            };
            document.addEventListener('mousemove', moveHandler);
          }
          overlay.style.backgroundImage = 'url(' + this.dataset.hoverImage + ')';
          overlay.style.display = 'block';
        });
      });

      card.addEventListener('mouseleave', restore);
    });
  }

  function observeGrid() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    new MutationObserver(function () {
      initPlpSwatchHover();
    }).observe(grid, { childList: true, subtree: false });
  }

  function init() {
    initPdpSwatches();
    initPlpSwatchHover();
    observeGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();